import styled from 'styled-components';


const CheckoutWrapper = styled.div`
  span {
    color: var(--checkout-highlight-text);
    font-weight: bold;
    font-size: 14px;
  }

  h5 {
    font-size: 14px;
    font-weight: lighter;
  }

  small {
    color: var(--checkout-product-descr);
    font-size: 13px;
    margin: 0px 0px 0px 5px;
  }

  .red-border {
    color: var(--borderRed);
  }

  min-height: calc(100vh - 70px);
  margin-bottom: 150px;

  .col-control {
    flex: auto;
  }

  .card-background {
    background: var(--checkoutCard);
    border-radius: 40px;
  }

  .width-control {
    min-width: 350px;
    max-width: 350px;
  }

  .round-input {
    border-radius: 40px;
  }

  .total {
    font-weight: bold;
    font-size: 17px;
  }

  h2 {
    font-size: 14px;
    font-weight: lighter;
    color: var(--productTitle);
  }

  h6 {
    font-size: 14px;
    font-weight: lighter;
    margin: 5px 0px 0px 0px;
    color: var(--productTitle);
  }
`;

export {CheckoutWrapper};